import "./Login.css";
const LoginLeftContainer = () => {
  return (
    <div className="container_container1">
      <div className="content_container11">
        Track. Manage. Optimize.
        <div className="content_container11_2">All in Real-time</div>
      </div>
      <div className="content_container12">
        <span
          style={{
            fontSize: "28px",
            fontWeight: "400",
            lineHeight: "42.38px",
            // textAlign:"left",
            // alignContent:"center"
          }}
        >
          RouteEye streamlines fleet management with GPS-based tracking, anomaly
          detection, and detailed analytics, helping you boost efficiency, cut
          costs, and optimize performance.
          <br />
          <br />
        </span>
        <span
          style={{ fontSize: "32px", fontWeight: "700", lineHeight: "39.38px" }}
        >
          Stay connected and in control.
        </span>
        <br />
        <br />
        <button
          className="customButton_add"
          variant="contained"
          color="secondary"
          style={{
            fontSize: "16px",
            height: "47px",
            padding: "12px 24px 12px 24px",
            borderRadius: "8px",
            textTransform: "none",
            gap: "10px",
            background: "#F2F2F3",
            boxShadow: "none",
            border: "2px solid #183059",
            color: "#1F242E",
            marginTop: "10px"
          }}
          onClick={() => window.open("https://routeeye.io/contact", "_blank")}
        >
          Contact Us
        </button>
      </div>
    </div>
  );
};

export default LoginLeftContainer;
